export const isNonNullObject = (v: unknown): v is Record<string, unknown> => {
  return typeof v === 'object' && v !== null;
};

export type NullableStringArray = string[] | null;

export type NullableString = string | null;
export const isNullableString = (nullable: unknown): boolean =>
  nullable === null || typeof nullable === 'string';

export type OptionalString = string | undefined;
export const isOptionalString = (optionalString: unknown): boolean =>
  typeof optionalString === 'undefined' || typeof optionalString === 'string';

export const isOptionalNumber = (optionalNumber: unknown): boolean =>
  typeof optionalNumber === 'undefined' || typeof optionalNumber === 'number';

export const isString = (maybeString: unknown): maybeString is string =>
  typeof maybeString === 'string';

export const isNumber = (maybeNumber: unknown): maybeNumber is number =>
  typeof maybeNumber === 'number';

export const isNullableNumber = (nullable: unknown): boolean =>
  nullable === null || typeof nullable === 'number';

export const isStringOrNumber = (
  maybeStringOrNumber: unknown
): maybeStringOrNumber is string | number =>
  isString(maybeStringOrNumber) || isNumber(maybeStringOrNumber);

export const isStringArray = (
  maybeStringArray: unknown
): maybeStringArray is string[] =>
  Array.isArray(maybeStringArray) &&
  maybeStringArray.every((item) => typeof item === 'string');

export const isNullableStringArray = (
  maybeStringArray: unknown
): maybeStringArray is string[] =>
  isStringArray(maybeStringArray) || maybeStringArray === null;

/**
 * tests Json for jsonyness
 * @returns The parsed json or false if not json
 */
export const isJSONString = (str: string): [boolean, unknown] => {
  try {
    return [true, JSON.parse(str)];
  } catch (e) {
    return [false, undefined];
  }
};

export enum REQ_STATUS {
  pending,
  success,
  error,
}

export type Total = Record<string, number>;
export const isTotal = (ttl: unknown): ttl is Total =>
  isNonNullObject(ttl) &&
  Object.keys(ttl).every((k) => typeof ttl[k] === 'number');

export interface AnyObject {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export function isArrayOf<T>(
  isType: (x: unknown) => x is T
): (xs: unknown) => xs is T[] {
  return (xs: unknown): xs is T[] => Array.isArray(xs) && xs.every(isType);
}
